import styled from "styled-components"

export const CovidUpdateSectionStyles = styled.section`
background-color: #f7f9fc;
p{
    color: #636262;
}
`;
